//createAbortController():
//* A simple factory for AbortController with optional parentAbortSignal
//* If there is a parentAbortSignal, when parentAbortSignal receives 'abort',
//  this abortController is aborted
export const createAbortController = (
  parentAbortSignal: AbortSignal | null = null, //optional
): AbortController => {
  let abortController: AbortController | null = new AbortController(); //if null it has been disposed

  if (parentAbortSignal && !parentAbortSignal.aborted) {
    //When parent signals 'abort', this abortController is aborted
    const parentAbortSignalHandler = () => {
      if (abortController) {
        abortController.abort();
      }
      //eslint-disable-next-line @typescript-eslint/no-use-before-define
      dispose(); //preemptive dispose() to save waiting for 'abort' listener
    };
    parentAbortSignal.addEventListener('abort', parentAbortSignalHandler);

    const dispose = () => {
      if (abortController) {
        parentAbortSignal.removeEventListener(
          'abort',
          parentAbortSignalHandler,
        );
        abortController.signal.removeEventListener('abort', dispose);
        abortController = null;
      } //otherwise already disposed
    };

    //Once aborted, this abortController can be disposed (abort is only called once)
    abortController.signal.addEventListener('abort', dispose);
  }

  return abortController;
};
